import React, { forwardRef, useEffect, useImperativeHandle } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import EditIcon from "@mui/icons-material/Edit";
import EditTableModal from "./EditTableModal";
import { Column, columnDef } from "./Columns";
import { useSelector } from "react-redux";
import MuiPagination from "@mui/material/Pagination";
import { TablePaginationProps } from "@mui/material/TablePagination";
import {
  DataGrid,
  GridColDef,
  GridPagination,
  GridPreProcessEditCellProps,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
  gridPageCountSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import { Alert, AlertProps, Snackbar } from "@mui/material";

import { AddOrDeleteColumn, handleAddNewRow } from "../../Utils/rowUtils";
import ConfirmDeleteModal from "../../Components/Common/ConfirmDeleteModal";

const columns: readonly Column[] = columnDef;

const DemandTable = forwardRef((props: any, ref: any) => {
  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId
  );
  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId
  );

  /**Redux state */
  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId
  );

  // const dispatch: any = useDispatch();
  const [page, setPage] = React.useState(0);
  // const [rows, setRows] = React.useState([]);
  const [confirmDelete, setConfirmDelete] = React.useState(false);
  const [deleteRowId, setDeleteRowId] = React.useState({ id: "" });
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [isOpenEditModal, setIsOpenEditModal] = React.useState(false);
  const [editedData, setEditedData] = React.useState({});
  const [getEditedTableData, setEditedTableData] = React.useState<any>([]);
  const [snackbar, setSnackbar] = React.useState<Pick<
    AlertProps,
    "children" | "severity"
  > | null>(null);
  const handleCloseSnackbar = () => setSnackbar(null);

  const [updatedVal, setUpdatedVal] = React.useState<any>(editedData);
  const [isProcessed, setIsProcessed] = React.useState(false);
  const [resetValues, setResetValues] = React.useState({
    max_no_of_shifts: 0,
    max_no_of_changeovers: 0,
  });

  useImperativeHandle(ref, () => ({
    ClearEditedData() {
      setEditedTableData([]);
    },
  }));

  useEffect(() => {
    setIsProcessed(props.isProcessed);
    // setRows(props.rowsData);
    props.handleGetEditData(getEditedTableData);
  }, [props.rowsData, getEditedTableData]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const isEditEnabled = useSelector(
    (state: any) => state.InputDataReducers.editFilterEnable
  );

  const handleEditMaster2TableRow = (e: any, row: any) => {
    setResetValues({
      max_no_of_shifts: row?.max_no_of_shifts,
      max_no_of_changeovers: row?.max_no_of_changeovers,
    });
    setIsOpenEditModal(true);
    setEditedData(row);
  };

  const handleChangeEditValue = (e: any) => {
    setUpdatedVal({
      ...editedData,
      ...updatedVal,
      [e.target.name]: e.target.value,
    });
  };

  const UpdateTableRow = () => {};

  const closeEditModal = () => {
    setIsOpenEditModal(false);
  };

  const handleClickOpenDeleteModal = (id: any) => {
    setDeleteRowId(id);
    setConfirmDelete(true);
    // deleteInMainId = id;
  };

  const handleCloseDelete = () => {
    setConfirmDelete(false);
    // deleteInMainId = "";
  };

  const handleonDelete = () => {
    if (deleteRowId) {
      props.setRows((prev: any[]) => {
        const rowToDelete = prev.find((row) => row.id === deleteRowId.id);
        if (rowToDelete) {
          const updatedRow = {
            ...rowToDelete,
            folder_id: 0,
            folder_Id: 0,
            scenario_id: 0,
          };

          setEditedTableData((prevEditedData: any[]) => [
            ...prevEditedData,
            updatedRow,
          ]);

          return prev.filter((row) => row.id !== deleteRowId);
        }

        return prev; // If no row is found, return the previous rows
      });
      console.log(getEditedTableData, "editedtabledata");
    }

    // Close the delete confirmation modal
    setConfirmDelete(false);
    setDeleteRowId({ id: "" });
  };

  // bulk edit

  const processRowUpdate = (newRow: any) => {
    const updatedRow = { ...newRow };

    // Check if this row already exists in editedTableData
    const existingRowIndex = getEditedTableData.findIndex(
      (row: any) => row.id === updatedRow.id
    );

    if (existingRowIndex !== -1) {
      // Update existing row instead of adding duplicate
      const updatedEditedData = [...getEditedTableData];
      updatedEditedData[existingRowIndex] = updatedRow;
      setEditedTableData(updatedEditedData);
    } else {
      // Add new row only if it doesn't exist
      setEditedTableData((prev: any[]) => [...prev, updatedRow]);
    }

    return updatedRow;
  };

  const tableColumns: GridColDef[] = [
    {
      field: "demand_location_Code",
      headerName: "Location Code",
      width: 150,
      align: "left",
      headerAlign: "left",
      editable: isEditEnabled,
      headerClassName: "super-app-theme--cell-header",
      cellClassName: "super-app-theme--cell-normal",
      hideable: false,
      sortable: false,
      // flex: 1,
    },
    {
      field: "demand_Location_Description",
      headerName: "Location Description",
      width: 230,
      align: "left",
      headerAlign: "left",
      editable: isEditEnabled,
      headerClassName: "super-app-theme--cell-header",
      cellClassName: "super-app-theme--cell-normal",
      hideable: false,
      sortable: false,
      flex: 1,
    },
    {
      field: "depot_Lat",
      headerName: "Lattitude",
      width: 230,
      align: "left",
      headerAlign: "left",
      headerClassName: "super-app-theme--cell-header",
      cellClassName: "super-app-theme--cell",
      hideable: false,
      sortable: false,
      flex: 1,
      editable: isEditEnabled,
      preProcessEditCellProps(params) {
        const invalid = params.props.value === "" ? true : false;
        if (invalid) {
          setSnackbar({
            children: "Please enter a valid number!",
            severity: "error",
          });
        }
        return { ...params.props, error: invalid };
      },
    },
    {
      field: "depot_Long",
      headerName: "Longitude",
      width: 230,
      align: "left",
      headerAlign: "left",
      editable: isEditEnabled,
      headerClassName: "super-app-theme--cell-header",
      cellClassName: "super-app-theme--cell",
      hideable: false,
      sortable: false,
      flex: 1,
      preProcessEditCellProps(params) {
        const invalid = params.props.value === "" ? true : false;
        if (invalid) {
          setSnackbar({
            children: "Please enter a valid number!",
            severity: "error",
          });
        }
        return { ...params.props, error: invalid };
      },
    },
    {
      field: "demand_Vol",
      headerName: "Volume",
      width: 190,
      align: "left",
      headerAlign: "left",
      editable: isEditEnabled,
      headerClassName: "super-app-theme--cell-header",
      cellClassName: "super-app-theme--cell",
      hideable: false,
      sortable: false,
      flex: 1,
      preProcessEditCellProps(params) {
        const invalid = params.props.value === "" ? true : false;
        if (invalid) {
          setSnackbar({
            children: "Please enter a valid number!",
            severity: "error",
          });
        }
        return { ...params.props, error: invalid };
      },
    },
    {
      field: "actions",
      headerName: "Action",
      sortable: false,
      width: 130,
      renderCell: (params: any) => {
        return AddOrDeleteColumn(
          params,
          props,
          isEditEnabled,
          handleClickOpenDeleteModal,
          handleAddNewRow
        );
      },
    },
  ];

  const tableData = {
    columns: tableColumns,
    rows: props.rowsData,
    initialState: {
      columns: {
        columnVisibilityModel: {
          id: false,
        },
      },
    },
    experimentalFeatures: {
      ariaV7: true,
    },
  };

  function Pagination({
    page,
    onPageChange,
    className,
  }: Pick<TablePaginationProps, "page" | "onPageChange" | "className">) {
    const apiRef = useGridApiContext();
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
      <MuiPagination
        color="primary"
        className={className}
        count={pageCount}
        page={page + 1}
        onChange={(event, newPage) => {
          onPageChange(event as any, newPage - 1);
        }}
      />
    );
  }

  const CustomPagination = (props: any) => {
    return <GridPagination ActionsComponent={Pagination} {...props} />;
  };
  const MyCustomNoRowsOverlay = () => (
    <div className="nodata-display-lable">No Data to Display.</div>
  );

  return (
    <>
      {isOpenEditModal && (
        <EditTableModal
          isOpen={isOpenEditModal}
          editedData={editedData}
          resetValues={resetValues}
          UpdateTableRow={UpdateTableRow}
          onClose={closeEditModal}
          handleChangeEditValue={handleChangeEditValue}
          headerName="Shift & Changeover Table"
        />
      )}
      {confirmDelete && (
        <ConfirmDeleteModal
          confirmDelete={confirmDelete}
          handleCloseDelete={handleCloseDelete}
          handleOnDelete={handleonDelete}
        />
      )}
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <DataGrid
          processRowUpdate={processRowUpdate}
          editMode="row"
          {...tableData}
          density="compact"
          {...(isEditEnabled && { checkboxSelection: true })}
          checkboxSelectionWidth={50}
          sx={{
            "& .MuiDataGrid-checkboxInput": {
              width: "30px", // Set the width of the checkbox itself
            },
            "& .MuiDataGrid-columnHeader--checkbox": {
              width: "50px", // Set the width of the checkbox column header
              minWidth: "50px", // Ensure the column doesn't shrink below this width
            },
            "& .MuiDataGrid-cell--checkbox": {
              width: "50px", // Set the width of the checkbox column cells
              minWidth: "50px",
            },
          }}
          rowSelectionModel={props.selectedRows || []}
          onRowSelectionModelChange={(newSelection: any) => {
            props.handleSelectionChange(newSelection);
          }}
          initialState={{
            ...tableData.initialState,
            pagination: { paginationModel: { pageSize: 10 } },
          }}
          pageSizeOptions={[10, 25, 50, 100]}
          showColumnVerticalBorder
          showCellVerticalBorder
          disableColumnSelector
          disableColumnMenu
          pagination
          slots={{
            pagination: CustomPagination,
            noRowsOverlay: MyCustomNoRowsOverlay,
            // toolbar: CustomToolbar,
          }}
          hideFooterSelectedRowCount
          disableRowSelectionOnClick
        />
      </Paper>
      {!!snackbar && (
        <Snackbar
          open
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={handleCloseSnackbar}
          autoHideDuration={6000}
        >
          <Alert {...snackbar} onClose={handleCloseSnackbar} />
        </Snackbar>
      )}
    </>
  );
});

export default DemandTable;
